module.exports = __webpack_public_path__ + "img/geofenceEnter.cb4a4132.svg";